/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilitySchemeSummarySchema } from './availabilitySchemeSummarySchema';
import { locationSummarySchema } from './locationSummarySchema';
import { skillSummarySchema } from './skillSummarySchema';
import { teamSchema } from './teamSchema';

export const resourceDetailResponseSchema = z.object({
  anonymized: z.boolean(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND']),
  get holidayScheme() {
    return availabilitySchemeSummarySchema;
  },
  id: z.int(),
  get location() {
    return z.union([locationSummarySchema, z.null()]).optional();
  },
  loopIds: z.array(z.int()),
  name: z.string(),
  organizationId: z.string(),
  get skills() {
    return z.array(skillSummarySchema);
  },
  sourceId: z.string().nullish(),
  status: z.enum(['ACTIVE', 'DEACTIVATED']),
  get teams() {
    return z.array(teamSchema);
  },
  type: z.enum(['RESOURCE', 'PLACEHOLDER']),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
  workforceCategory: z.enum(['EMPLOYEE', 'CONTRACTOR', 'VENDOR', 'FREELANCER']),
  get workloadScheme() {
    return availabilitySchemeSummarySchema;
  },
});
